<template>
    <b-standard-card
        :title="translations.title[lang]"
        :submit-text="{ el: 'Αποθήκευση', en: 'Save', it: 'Salva' }"
        :loading="loading"
        class="mt-5"
        height="auto"
        :error-message="errorMessage"
        @submit="updateCompanyName({type: 'company_name',
         body: {name}})"
    >
        {{ translations.description[lang] }}
        <b-text-field
            :label="translations.name[lang]"
            v-model="name"
        ></b-text-field>
    </b-standard-card>
</template>

<script>
import translations from "@/utils/translations/loyaltyPanel/businessProfile/companyName";
import {mapState, mapGetters, mapMutations, mapActions} from "vuex";

export default {
    name: "CompanyName",

    mixins: [translations],

    
    data() {
        return {
            name: ''
        };
    },
  
    computed: {
        lang() {
            return this.$route.params.lang;
        },
        loading() {
            return this.$store.state.loyaltyPanel.businessProfile.loading.company_name;
        },

        errorMessage() {
            return this.$store.state.loyaltyPanel.businessProfile.errorMessage
                .company_name;
        },
        resetSuccess() {
            return this.$store.state.loyaltyPanel.businessProfile.resetSuccess
                .company_name;
        },

        ...mapState("loyaltyPanel",["company"]),

     

    },

    methods: {
        ...mapActions("loyaltyPanel/businessProfile", ["updateCompanyName"]),
    },

    
    watch: {
        company: {
            immediate: true,
            handler(val) {
                // if (val?.name) {
                    this.name = val?.name || ''  
                // }
            },
            deep: true
        }
    }

};
</script>
